import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import AllAccessCatForm from "./AllAccessCatForm";
import CommonStructured from "../common-components/CommonStructured";
import { fetchAllAccessPlansData } from "../../redux/plans-reducers/plansSlice";
import AllAccessCatListings from "./AllAccessCatListings";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";

const AllAccessCategories = ({ userInfoData }) => {
  const dispatch = useDispatch();
  //   const { allAccessPlans, allAccessPlansLoading, allAccessPlansError } =
  //     useSelector((state) => state.plans);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  //   const iniAllFilter = {
  //     isActive: "",
  //     searchString: "",
  //   };
  //   const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    tbData: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  function getAllAccessPassCategories(filters) {
    dispatch(
      fetchAllAccessPlansData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllAccessPassCategories(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  const tbColumnsCG = [
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
  ];

  const tbColumnsCF = [
    {
      dataField: "uid",
      text: "feature",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.feature_name || "NA"}</span>;
      },
    },
  ];

  return (
    <Container className="bg-cloud-k">
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        {modValues.cardName === "add" || modValues.cardName === "edit" ? (
          <AllAccessCatForm
            userInfoData={userInfoData}
            isEdit={modValues.cardName === "edit"}
            rowData={modValues.rowData}
            closeModal={onCloseModal}
            callFunction={() => getAllAccessPassCategories(filters)}
          />
        ) : modValues.cardName === "category_gyms" ? (
          <div className="createNewCTOModalContainer mod-width-50p">
            <ModalHeadAndClose
              title={`${modValues.cardName?.replace(/_/g, " ")}`}
              onClose={onCloseModal}
            />

            <div className="fullWidthFlexCenter overflowAuto separatedTable mt15">
              <PaymentLinkTable
                tableData={modValues.tbData}
                tableColumns={tbColumnsCG}
              />
            </div>
          </div>
        ) : modValues.cardName === "category_features" ? (
          <div className="createNewCTOModalContainer mod-width-50p">
            <ModalHeadAndClose
              title={`${modValues.cardName?.replace(/_/g, " ")}`}
              onClose={onCloseModal}
            />

            <div className="fullWidthFlexCenter overflowAuto separatedTable mt15">
              <PaymentLinkTable
                tableData={modValues.tbData}
                tableColumns={tbColumnsCF}
              />
            </div>
          </div>
        ) : null}
      </Modal>

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"All Access Pass Categories"}
            createBtnTxt={"+ Add New Category"}
            onClickCreateBtn={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "add",
              }))
            }
            isReload={() => getAllAccessPassCategories(filters)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AllAccessCatListings
            userInfoData={userInfoData}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            callFunction={() => getAllAccessPassCategories(filters)}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default AllAccessCategories;
